/**
 * O editor de cada parâmetro de `billing.business_properties` (AF-4126). Todos recebem e devolvem o
 * `value` como texto; os de JSON o interpretam por dentro.
 */
import ReceivingBankAccountSelect from '../../../molecules/payment/ReceivingBankAccountSelect';
import SelectTextField, { OptionProps } from '../../../molecules/SelectTextField';
import TextArea from '../../../molecules/TextArea';
import TextEdit from '../../../molecules/TextEdit';
import {
    BILL_CESSION_DESCRIPTION, BOLETO_PAID_ACTION, BOLETO_PAID_DATE, BOLETO_RECEIVING_BANK_ACCOUNT,
    CHARGE_INVOICES_ACTIONS, DEFAULT_PAYEE, INVOICE_PAYMENT_ACTION, PAYMENT_SOURCES,
} from '../services/businessPropertyRules';
import ChargeInvoicesActionsEditor from './ChargeInvoicesActionsEditor';
import InvoicePaymentActionEditor from './InvoicePaymentActionEditor';
import PaymentSourcesEditor from './PaymentSourcesEditor';

export const VALUE_ID = 'business-property-value';

const CHOICES: Record<string, OptionProps[]> = {
    [BOLETO_PAID_DATE]: [
        { value: 'WHEN_RECEIVED', label: 'WHEN_RECEIVED' },
        { value: 'WHEN_PAID', label: 'WHEN_PAID' },
    ],
    [BOLETO_PAID_ACTION]: [
        { value: 'EFFECT_PAYMENT', label: 'EFFECT_PAYMENT' },
        { value: 'MARK_PAYMENT', label: 'MARK_PAYMENT' },
    ],
};

interface Props {
    name: string;
    value: string;
    onChange: (value: string) => void;
    error: string | null;
}

const BusinessPropertyEditor = ({ name, value, onChange, error }: Props) => {
    const fieldError = error ?? undefined;

    if (name === DEFAULT_PAYEE) {
        return <TextEdit id={VALUE_ID} label="Valor" value={value} errorMessage={fieldError} onChange={e => onChange(e.target.value)} />;
    }
    if (name === BILL_CESSION_DESCRIPTION) {
        return <TextArea id={VALUE_ID} label="Valor" rows={6} value={value} errorMessage={fieldError} onChange={e => onChange(e.target.value)} />;
    }
    if (name === BOLETO_RECEIVING_BANK_ACCOUNT) {
        return <ReceivingBankAccountSelect id={VALUE_ID} value={value} onChange={onChange} />;
    }
    if (CHOICES[name]) {
        return <SelectTextField id={VALUE_ID} label="Valor" items={CHOICES[name]} hideEmptyOption value={value} onChange={e => onChange(e.target.value)} />;
    }
    if (name === PAYMENT_SOURCES) return <PaymentSourcesEditor value={value} onChange={onChange} error={error} />;
    if (name === INVOICE_PAYMENT_ACTION) return <InvoicePaymentActionEditor value={value} onChange={onChange} />;
    if (name === CHARGE_INVOICES_ACTIONS) return <ChargeInvoicesActionsEditor value={value} onChange={onChange} />;
    return null;
};

export default BusinessPropertyEditor;
